import React from "react";
import { m } from "framer-motion";
import {
  selectIsGameOver,
  selectLevel,
  selectScore,
} from "store/game/selectors";
import { useDispatch, useSelector } from "react-redux";
import { resetGame, setSelectedLevel } from "store/game";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import CountUp from "react-countup";
import Levels from "pages/home/Levels";
import { useNavigate } from "react-router-dom";
import Button from "components/Button";

export default function GameOver() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isGameOver = useSelector(selectIsGameOver);
  const score = useSelector(selectScore);
  const selectedLevel = useSelector(selectLevel);

  function handleResetGame() {
    dispatch(resetGame());
  }

  return (
    <m.div
      initial={{ opacity: 0, display: "none" }}
      animate={{
        opacity: isGameOver ? 1 : 0,
        display: isGameOver ? "flex" : "none",
      }}
      transition={{
        duration: 1,
      }}
      className="flex flex-col overflow-y-auto p-6 justify-center items-center w-full h-full bg-white animate-fade-in-slower rounded text-slate-900"
    >
      <div className="flex flex-grow w-full">
        <div className="basis-2/3 flex-grow p-12 flex-col flex justify-between">
          <div>
            <h1 className="text-xl lg:text-5xl font-bold text-violet-800">
              Təbriklər!
            </h1>
            <div className="text-lg lg:text-2xl mt-3 text-slate-400">
              Oyun başa çatdı
            </div>
          </div>
          <Button
            onClick={(e) => {
              dispatch(setSelectedLevel(null));
              navigate("/");
            }}
            className="text-slate-50 w-fit"
          >
            Ana səhifə
          </Button>
        </div>
        <div className="basis-1/3 flex-grow text-center flex justify-center flex-col gap-16">
          <div>
            <small className="font-semibold">
              {selectedLevel?.name} səviyyə
            </small>
            <h2 className="text-4xl lg:text-6xl font-bold text-violet-800">
              <CountUp start={0} end={score} />
            </h2>
          </div>
          <div
            onKeyDown={(e) => {
              if (e.key === "Enter") handleResetGame();
            }}
            tabIndex={0}
            onClick={handleResetGame}
            className="custom-focus hover:text-violet-600 duration-200 cursor-pointer w-fit mx-auto"
          >
            <FontAwesomeIcon
              className=" text-4xl md:text-6xl lg:text-7xl"
              icon={faRotateLeft}
            />
            <p className="mt-3">Yenidən başlat</p>
          </div>
        </div>
      </div>
      <div className="w-full text-slate-50 h-36">
        <Levels
          onSelect={(level) => {
            dispatch(setSelectedLevel(level));
            navigate("/load", {
              state: { level },
            });
          }}
          loadingProps={{ className: " text-slate-900" }}
        />
      </div>
    </m.div>
  );
}
